















import { Component, Prop, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { AdhocReportRequest, AdhocReportService, PresalesCallbackReportRequest } from './api'
import { FormStructure } from '@master/model/structure/FormStructure'
import { inject } from 'inversify-props'
import { SharedVariable } from '@core/model/SharedVariable'

@Component({
  components: {
    AppForm
  }
})
export default class AdhocSection extends Vue {
  adhocModel: AdhocReportRequest = {} as AdhocReportRequest
  @Prop() typeOfReport: AdhocReportRequest.typeOfReport

  @inject() readonly sharedVariable: SharedVariable

  async runAdhocReport () {
    const { uiService } = this.sharedVariable
    uiService.loading.addLoadingTask('adhocReportRun')
    try {
      this.adhocModel.typeOfReport = this.typeOfReport
      const res = await AdhocReportService.runAdHocReport(this.adhocModel)
      if (typeof res === 'string' && res.includes('REST API not found')) {
        throw new Error('Running Adhoc Report is currently unavailable.')
      } else {
        console.log(res, res.includes('REST API not found'))
      }
      const BOM = '\ufeff' // add BOM as first char in the file to force using UTF-8 encoding
      const blob = new Blob([BOM + res], { type: 'text/csv;charset=utf-8' })
      const elem = window.document.createElement('a')
      elem.href = window.URL.createObjectURL(blob)
      elem.download = `${this.typeOfReport}.csv`
      document.body.appendChild(elem)
      elem.click()
      document.body.removeChild(elem)
    } catch (err) {
      uiService.alert.show({
        type: 'error',
        message: err
      })
    } finally {
      uiService.loading.removeLoadingTask('adhocReportRun')
    }
  }

  get adhocStructure (): FormStructure<PresalesCallbackReportRequest> {
    return [
      {
        type: 'date',
        label: 'Approved Date From',
        key: 'fromTimestamp'
      },
      {
        type: 'date',
        label: 'Approved Date To',
        key: 'toTimestamp'
      }
    ]
  }
}
